<template>
  <div>
    <v-row class="mt-4">
      <v-col
        xl="2"
        lg="2"
        md="3"
        sm="3"
        xs="12"
        cols="12"
        class="align-center justify-center text-center"
      >
        <v-card class="pa-4" outlined>
          <img
            class="w-100"
            :src="
              divisionDetails.publisherLogo
                ? divisionDetails.publisherLogo
                : '/no-image.png'
            "
            alt=""
          />
        </v-card>
      </v-col>
      <v-col
        xl="10"
        lg="10"
        md="9"
        sm="9"
        xs="12"
        cols="12"
        v-if="divisionDetails.name"
      >
        <div class="mb-4">
          <h1 class="font-weight-bold mt-1 fs-xxxxxlarge">
            سری "{{ divisionDetails.name }}"
          </h1>
          <h2 class="mb-4 font-weight-bold mt-5 fs-large">
            <a
              :href="`/publisher/${divisionDetails.publisherName.replaceAll(
                ' ',
                '-'
              )}-${divisionDetails.publisherId}`"
              target="_self"
              rel="noopener noreferrer"
              style="z-index: 100"
            >
              انتشارات "{{ divisionDetails.publisherName }}"
            </a>
          </h2>
        </div></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  name: "DivisionInfo",
  props: ["divisionDetails"],
};
</script>

<style lang="scss">
.ql-align-justify {
  text-align: justify;
}
</style>
